module.exports = __webpack_public_path__ + "static/media/pierre-cv-fr.a0bf0d2c.pdf";